import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CenterProfession} from '../modules/user/components/dictionary/profession/center-profession';

@Injectable()
export class CenterProfessionService {

  constructor(private _http: HttpClient) {
  }

  get(code: string) {
    return this._http.get<any>('api/a/dictionary/profession/get/' + code);
  }

  getById(id: number) {
    return this._http.get<any>('api/a/dictionary/profession/find/' + id);
  }

  getList(params: any, lang: number) {
    return this._http.post<any>('api/a/dictionary/profession/getList/' + lang, params);
  }

  save(profession: CenterProfession) {
    return this._http.post<any>('api/a/dictionary/profession/save', profession);
  }

  getListByUserModule(module: string, universityId?: number) {
    if (!universityId) {
      universityId = 0;
    }
    return this._http.get<any[]>(`api/a/dictionary/profession/list/by/user/module/${module}/${universityId}`);
  }

  getListByCollegeId(universityId?: number) {
    if (!universityId) {
      universityId = 0;
    }
    return this._http.get<any[]>(`api/a/dictionary/profession/list/by/college/${universityId}`);
  }

  getListByRegionId(regionId: number) {
    return this._http.get<any[]>(`api/a/dictionary/profession/list/by/region/${regionId}`);
  }

  getCenterProfessionsWithGrant(filter: any) {
    return this._http.post<any[]>(`api/s/enrollApplication/centerProfessions/grant`, filter);
  }

  getCenterProfessionsWithGrantOnlyIds(filter: any) {
    return this._http.post<any[]>(`api/s/enrollApplication/centerProfessions/grant/onlyIds`, filter);
  }
}



// WEBPACK FOOTER //
// ./src/app/common_services/center-profession.service.ts